import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Background from '../../blanks/common/Background';
import corner2 from '../../../assets/img/icons/spot-illustrations/corner-2.png';

function DescriptionForm() {
  return (
    <Card className="h-100">
      <Background image={corner2} className="rounded-soft bg-card" />
      <Card.Header className="cardHeader">
        <h5 className="mb-0">Для створення облікового запису необхідно виконати декілька простих кроків.</h5>

      </Card.Header>
      <Card.Body>
        <p className="mb-0">1. Авторизуватись за допомогою ЕЦП. Ми перевіримо ваш доступ до системи Логіка. Ви зможете продовжити, тільки якщо ви маєте право користуватися системою Логіка.</p>
        <p className="mb-0">2. Заповнити реєстраційну форму.</p>
        <p className="mb-0">3. Отримати на електронну пошту запрошення на встановлення паролю та вхід до системи.</p>
        <div className="float-end ms-3">
          <a
            href={`${process.env.PUBLIC_URL}/help/start.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            Завантажити посібник користувача
            {' '}
            <FontAwesomeIcon icon={faQuestionCircle} bounce />
          </a>
        </div>
      </Card.Body>
      <Card.Footer>
        <p className="mb-0">Зателефонуйте нам у разі потреби, і ми залюбки допоможемо вам!</p>
        <p className="mb-0">(044) 364-07-87(84), (044) 424-04-34; </p>
        <p className="mb-0">(067) 825-43-71, (067) 825-43-72; </p>
        <p className="mb-0">(066) 382-19-98, (050) 858-07-59;</p>
      </Card.Footer>
    </Card>
  );
}

export default DescriptionForm;
